import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnInit,
} from "@angular/core";
import { MyTicketsStatusEnum } from "../../enums/my-tickets-status-enum";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-my-tickets-tabs",
  templateUrl: "./my-tickets-tabs.page.html",
  styleUrls: ["./my-tickets-tabs.page.scss"],
})
export class MyTicketsTabsPage implements OnInit {
  tabs!: any[];
  MyTicketsStatusEnum = MyTicketsStatusEnum;
  tabIndex: number = 0;
  isMobileView: boolean = false;
  errorMessage!: string;
  successMessage!: string;
  reload = false;

  constructor(
    public translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.checkIfMobile();
    this.tabs = [
      {
        title: "Tabs." + MyTicketsStatusEnum.UpComingTickets,
        active: false,
      },
      {
        title: "Tabs." + MyTicketsStatusEnum.PastTickets,
        active: false,
      },
    ];
    this.tabs[0].active = true;
  }

  @HostListener("window:resize", [])
  onResize() {
    this.checkIfMobile();
  }

  checkIfMobile() {
    const screenWidth = window.innerWidth;
    this.isMobileView = screenWidth <= 1024;
  }

  handleSuccessMessage(successMessage: string) {
    this.successMessage = successMessage;
    this.scrollToTop();
    this.cdr.detectChanges();
  }

  handleErrorMessage(errorMessage: string) {
    this.errorMessage = errorMessage;
    this.scrollToTop();
  }

  private scrollToTop(): void {
    if (window && window.scrollTo) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  changeTab(index: number) {
    this.tabs = this.tabs.map((tab, i) =>
      i === index ? { ...tab, active: true } : { ...tab, active: false }
    );

    this.tabIndex = index;
  }
}
